import { useAccount } from 'modules/account/hooks/useAccount';
import { useUser } from 'modules/user/hooks/useUser';

export const useAccountAddress = () => {
  const { group } = useAccount();
  const { address: authAddress } = useUser();

  const accountAddress = group || authAddress!;

  return { accountAddress };
};
